import { KeyValue } from '../../common/redux/api/web-api'
import { IConnectorId } from '../../ui/ConnectorSelect'
import { getConnectorCurrentLimitFromConfig, CurrentLimitType } from '../get-connector-current-limit-from-config'

export const getConnectorSelectedCurrentLimit = (configKeys: Array<KeyValue>, connectorId: IConnectorId): number => {
    const installationMaxCurrent = getConnectorCurrentLimitFromConfig(
        configKeys,
        CurrentLimitType.INSTALLATION_CURRENT,
        connectorId
    )
    const userMaxCurrent = getConnectorCurrentLimitFromConfig(
        configKeys,
        CurrentLimitType.USER_CURRENT_LIMIT,
        connectorId
    )
    const maxCurrent = getConnectorCurrentLimitFromConfig(configKeys, CurrentLimitType.MAX_CURRENT, connectorId)
    return Math.min(installationMaxCurrent, userMaxCurrent, maxCurrent)
}
